<template>
  <el-dialog :title="title" :visible.sync="visible" @closed="dialogClosed">
    <el-form :model="school">
      <el-form-item label="数据类型" prop="datatype">
        <el-radio-group v-model="school.datatype">
          <el-radio label="1">学生</el-radio>
          <el-radio label="2">教师</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" prop="grade" v-show="school.datatype === '1'">
        <el-cascader
          v-show="school.datatype === '1'"
          style="margin-left: 68px"
          :placeholder="'年级选择'"
          :options="classOption"
          :props="props"
          collapse-tags
          clearable
          v-model="school.grade"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="determine" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { getGradesBySchoolStage } from '@/util/paramsUtils'
export default {
  name: 'SchoolManageDialog',
  data: function() {
    return {
      visible: false,
      school: {
        datatype: '1',
        grade: []
      },
      props: { multiple: true, expandTrigger: 'hover' },
      loading: false
    }
  },
  methods: {
    // 确定
    determine() {
      this.deleteSchool()
    },
    // 取消
    cancel() {
      this.visible = false
    },
    // 隐藏弹框
    dialogClosed() {
      this.school = {
        datatype: '1',
        grade: []
      }
      this.$emit('update:dialogShow', false)
    },
    // 删除学校教师或学生
    deleteSchool() {
      this.loading = true
      let grades = this.school.grade.reduce((data, val) => {
        data.push(val[1])
        return data
      }, [])
      if (this.school.datatype === '1') {
        if (grades.length === 0) {
          this.loading = false
          this.$message.error('请选择年级')
          return false
        }
        // 学生删除，判断年级是否全选
        grades =
          grades.length === this.classOption[0].children.length ? null : grades
        this.$xhrDelete(
          `/eval/backyard/school/${this.schoolId}/students`,
          {
            grades,
            hasArray: true
          },
          {
            timeout: 60000
          }
        )
          .then(({ code, data }) => {
            if (code === 'SUCCESS') {
              this.$message.success(`删除成功，删除了${data}个学生`)
              this.cancel()
            }
          })
          .catch(e => {
            console.log(e)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        // 教师
        this.$xhrDelete(
          `/eval/backyard/school/${this.schoolId}/teachers`,
          null,
          {
            timeout: 60000
          }
        )
          .then(({ code, data }) => {
            if (code === 'SUCCESS') {
              this.$message.success(`删除成功，删除了${data}个教师`)
              this.cancel()
            }
          })
          .catch(e => {
            console.log(e)
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  },
  computed: {
    classOption() {
      const schoolStage = getGradesBySchoolStage(this.dialogSchoolStage)
      return [
        {
          value: 'all',
          label: '全部',
          children: schoolStage.map(s => {
            return {
              label: s.name,
              value: s.value
            }
          })
        }
      ]
    }
  },
  watch: {
    dialogShow: {
      handler(newval) {
        this.visible = newval
      },
      immediate: true
    }
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '用户数据管理'
    },
    dialogSchoolStage: {
      type: [String, Number]
    },
    schoolId: {
      type: [String, Number]
    }
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/operate/SchoolManageDialog.vue